<template>
  <div id="questions-div">
    <container group-name="questions" lock-axis="y" drag-handle-selector=".question-block__drag" @drop="listOnDrop">
      <draggable v-for="(item, index) in questions" :key="index">
        <questions-row :model="item" :index="index" :questions-length="questions.length" />
      </draggable>
    </container>
  </div>
</template>

<script>
import QuestionsRow from './Row.vue';
import { Container, Draggable } from 'vue-smooth-dnd';

export default {
  name: 'QuestionList',

  components: {
    Container,
    Draggable,
    QuestionsRow
  },

  props: {
    questions: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    listOnDrop(droppedItems) {
      // Перемешивание после отпускания кнопки мыши
      const { removedIndex, addedIndex, payload } = droppedItems;
      if (removedIndex === null && addedIndex === null) return this.questions;

      const result = [...this.questions];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      // Добавление sort_order свойства
      const newOrderedList = [];
      let currentOrder = 0;

      result.forEach(item => {
        const newItem = Object.assign({}, item);
        currentOrder += 1000;
        newItem.sort_order = currentOrder;

        newOrderedList.push(newItem);
      });

      this.$emit('set-questions', newOrderedList);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
  overflow: visible;
}

#questions-div {
  span {
    outline: none;
    border: none;
    &:focus {
      outline: none;
      border: none;
    }
  }
}
</style>
